import { ref, computed } from "vue";
const useExpand = (props, allRowKeys, emit) => {
  const getDefaultExpandedRowKeys = () => {
    var _a, _b, _c;
    if ((_a = props.expandable) == null ? void 0 : _a.defaultExpandedRowKeys) {
      return (_b = props.expandable) == null ? void 0 : _b.defaultExpandedRowKeys;
    }
    if ((_c = props.expandable) == null ? void 0 : _c.defaultExpandAllRows) {
      return [...allRowKeys];
    }
    return [];
  };
  const _expandedRowKeys = ref(getDefaultExpandedRowKeys());
  const expandedRowKeys = computed(() => {
    var _a, _b;
    return (_b = (_a = props.expandable) == null ? void 0 : _a.expandedRowKeys) != null ? _b : _expandedRowKeys.value;
  });
  const handleExpand = (rowKey) => {
    const isExpanded = expandedRowKeys.value.includes(rowKey);
    const newExpandedRowKeys = isExpanded ? expandedRowKeys.value.filter((key) => rowKey !== key) : expandedRowKeys.value.concat(rowKey);
    _expandedRowKeys.value = newExpandedRowKeys;
    emit("expand", rowKey);
    emit("expandedChange", newExpandedRowKeys);
  };
  return {
    expandedRowKeys,
    handleExpand
  };
};
export { useExpand };
